// src/store/store.ts
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import scanReducer from "./scanSlice";
import dspmScanReducer from "./dspmScanSlice";
import leakGuardReducer from "./leakGuardSlice";
import vulnerabilityScanReducer from "./VS_Slice";
import cspmScanReducer from "./cspmScanSlice";
import cspmAttackPathReducer from "./cspmAttackPathSlice";
import dashboardReducer from "./dashboardSlice";
import userReducer from "./userSlice";
import { setStore } from "@/lib/session-utils"; 

const persistConfig = {
  key: "user",
  storage,
  // Persist the entire user slice
};

const persistedUserReducer = persistReducer(persistConfig, userReducer);

export const store = configureStore({
  reducer: {
    scan: scanReducer,
    dspmScan: dspmScanReducer,
    leakGuard: leakGuardReducer,
    vulnerabilityScan: vulnerabilityScanReducer,
    cspmScan: cspmScanReducer,
    cspmAttackPath: cspmAttackPathReducer,
    dashboard: dashboardReducer,
    user: persistedUserReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});
setStore(store);
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
